<template>
    <TransitionRoot as="template" :show="overlayerState.rightDrawer">
      <Dialog class="relative z-10" @close="closeOverlayer">
        <TransitionChild as="template" enter="ease-in-out duration-500" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-500" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </TransitionChild>
  
        <div class="fixed inset-0 overflow-hidden"  v-if="overlayerState.rightDrawer">
          <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                <DialogPanel class="pointer-events-auto w-screen max-w-md">
                  <Cart v-if="overlayerComponent == 'Cart'" />
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Global notification live region, render this permanently at the end of the document -->
    <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
        style="z-index: 9999;">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                leave-to-class="opacity-0" v-for="notification in notifications" :key="notification.id">
                <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 ">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" v-if="notification.type == 'info'" />
                                <CheckCircleIcon class="h-6 w-6 text-red" aria-hidden="true" v-if="notification.type == 'warning'" />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5" v-on:click="router.push(notification.link);">
                                <p class="text-sm font-medium text-gray-900">{{notification.title}}</p>
                                <p class="mt-1 text-sm text-gray-500">{{notification.content}}</p>
                            </div>
                            <div class="ml-4 flex flex-shrink-0">
                                <button type="button" @click="store.dispatch('core/removeNotification',notification)"
                                    class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2">
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
  </template>
  <script>
  export default {
      name: 'Shop Overlayer',
      inheritAttrs: false,
  }
  </script>

  <script setup>
  import { ref, watch, computed} from 'vue'
  import { useStore } from 'vuex'
  import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
  import { useRoute, useRouter } from 'vue-router';
  import Cart from '../components/shop/Cart.vue';
  import { XMarkIcon } from '@heroicons/vue/24/outline'
  import { CheckCircleIcon } from '@heroicons/vue/24/outline'

  const overlayerState = ref({
    leftDrawer: false,
    rightDrawer: false,
    full: false,
    modal: false
  })
  const route = useRoute();
  const router = useRouter();
  const closeOverlayer = function(){
    router.push(route.path);
  }

  const overlayerComponent = ref('');

  const store = useStore();
  const notifications = computed(() => store.state.core.notifications);

  const overlayRoutes = [
    {
        path: '#cart',
        component: 'Cart',
        overlay: 'rightDrawer',
    },
  ]

  watch(notifications, (currentValue, oldValue) => {
    if(currentValue.length > 0){
      let notification = currentValue[0];
      setTimeout(()=>{ store.dispatch('core/removeNotification',notification)},3000);
    }
  },
  { deep: true });

  watch(route, (to, from) => {
    let activeRoute = null;
    console.log('Checking route for overlayer', to.fullPath)

    if (
        to && to.hash &&
        overlayRoutes.filter((route) => route.path === to.hash.split('-')[0])
    ) {
        const overlayerRoute = overlayRoutes.filter(
            (route) => route.path === to.hash.split('-')[0]
        )
        if (overlayerRoute && overlayerRoute.length == 1) {
            activeRoute = overlayerRoute[0];
        }
    }
    Object.keys(overlayerState.value).forEach(function (key, index) {
        if (activeRoute != null && activeRoute.overlay == key) {
            overlayerState.value[key] = true;
            overlayerComponent.value = activeRoute.component;
        } else {
            overlayerState.value[key] = false;
        }
    },{
        immediate: true,
        deep: true,
    });
    },
)
</script>